/**
 * Combine all reducers in this file and export the combined reducers.
 */
import { combineReducers } from 'redux';

// Add any additional reducers here
import apiReducer from './apiReducer';

export default combineReducers({
	api: apiReducer,
});
